<mat-sidenav-container class="layout">
  <mat-sidenav #sidenav mode="side" [opened]="true" class="layout-sidebar" [fixedInViewport]="mobileQuery.matches" [disableClose]="true">
      <button *ngIf="this.sharedService.showButton" mat-icon-button (click)="toggleRightSidenav()" style='padding-top: 10px;position: absolute;left: -7px;'>
        <i class="fas fa-bars"></i>
      </button>
      <app-sidebar></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="layout-content">
    <div class="header-home">
      <div class="borde-repetido"></div>
      <div style="display: flex;" >
        <button *ngIf="this.sharedService.showButton && this.sharedService.showButton2" mat-icon-button (click)="toggleRightSidenav()" style='padding-top: 10px;'>
          <i class="fas fa-bars"></i>
        </button>
        <div style="float: left;padding-bottom: 20px;padding-top: 20px;"  [ngStyle]="{'width':!(sharedService.userSession && sharedService.userSession.id)?'calc(100% - 75px)':'100%'}">
          PNLOTI - Política Nacional de Lenguas Originarias, Tradición Oral e Interculturalidad al 2040

        </div>
        <div style="text-align:right;float: right; width: 55px;padding-top: 20px;padding-right: 40px;" *ngIf="!(sharedService.userSession && sharedService.userSession.id)">
          <button mat-raised-button class="btn_wine" (click)="goLogin()">Login</button>
        </div>
      </div>
    </div>
    <div style="display: flex; height: calc(100% - 110px);">
      <ng-template [ngIf]="sharedService.abrirSidebarObjetivos">
        <app-sidebar-objetivos></app-sidebar-objetivos>
      </ng-template>

      <div [ngStyle]="{'width':sharedService.abrirSidebarObjetivos?'calc(100vw - 250px)':'100vw'}" style="overflow-x: auto;">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="footer-home">
      <br>
      MINISTERIO DE CULTURA | Sede central: Av. Javier Prado Este 2465 | San Borja, Lima Perú | Central Telefónica: (511)-7140102
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
